module.exports = __webpack_public_path__ + "static/media/am.41e61056.svg";